<script >
import accountantsRequest from '../../component/cdevs/accountantsRequest/index.vue'

export default {
  components:{
    accountantsRequest
  }
}
</script>

<template>
  <div class="p-6 all">
    <div>
      <accountantsRequest />
    </div>
  </div>
</template>

<style scoped>
.all{
  min-height: 100vh;
}
</style>
